<template>
	<v-container fluid class="pt-0">
		<v-row>
			<v-col cols="12">
				<v-card flat outlined>
					<v-card-title class="justify-center"> {{ title }}</v-card-title>
					<v-card-text>
						<v-row>
							<v-col cols="1">
								<v-simple-checkbox
									:ripple="false"
									v-model="showUnactive"
									:label="$t('labels.showUnactives')"
								>
								</v-simple-checkbox> </v-col
							><v-col cols="11" clas="mt-0"> {{ $t('labels.showUnactives') }} </v-col>
							<v-col>
								<v-data-table
									:headers="objectHeaders"
									:items="objectsList"
									fixed-header
									dense
									class="row-item"
									:items-per-page="-1"
									:hide-default-footer="true"
									:height="400"
									:no-data-text="$t('labels.noData')"
								>
									<template v-slot:item="row">
										<tr
											:class="{ 'cursor-pointer': true }"
											v-if="
												row.item.active == 1 || (row.item.active == 0 && showUnactive == true)
											"
										>
											<td @click="editObject(row.item)">
												<v-tooltip bottom>
													<template v-slot:activator="{ on, attrs }">
														<span v-bind="attrs" v-on="on">{{ row.item.name }}</span>
													</template>
													<span>{{ $t('tooltips.edit') }}</span>
												</v-tooltip>
											</td>
											<td width="10" v-if="row.item.active == 1">
												<v-tooltip bottom>
													<template v-slot:activator="{ on, attrs }">
														<v-btn
															icon
															v-bind="attrs"
															@click="changeStatus(row.item)"
															v-on="on"
														>
															<v-icon small>fas fa-trash</v-icon>
														</v-btn>
													</template>
													<span>{{ $t('tooltips.delete') }}</span>
												</v-tooltip>
											</td>
											<td width="10" v-else>
												<v-tooltip bottom>
													<template v-slot:activator="{ on, attrs }">
														<v-btn
															icon
															v-bind="attrs"
															@click="changeStatus(row.item)"
															v-on="on"
														>
															<v-icon small>fas fa-plus</v-icon>
														</v-btn>
													</template>
													<span>{{ $t('tooltips.activate') }}</span>
												</v-tooltip>
											</td>
										</tr>
									</template>
									<template v-slot:footer>
										<v-row>
											<v-col cols="12">
												<v-row dense wrap>
													<v-col cols="9">
														<InputField
															:maxlength="50"
															v-model="object.name"
															:errorBorder="!objectValidation.name"
															:label="'* ' + $t('fields.name')"
															@keypress.native.enter="saveClick"
														></InputField>
													</v-col>

													<v-col cols="3" class="mt-2">
														<v-btn
															class="ml-2 mr-2"
															color="primary"
															@click="saveClick(null)"
														>
															<v-icon small>fa-plus</v-icon>
														</v-btn>
													</v-col>
												</v-row>
											</v-col>
										</v-row>
									</template>
								</v-data-table>
							</v-col>
						</v-row>
					</v-card-text>
				</v-card>
			</v-col>
		</v-row>
		<v-dialog persistent v-model="objectEditDialog" width="600">
			<v-card>
				<v-card-title>
					{{ $t('labels.edit') }}
				</v-card-title>
				<v-card-text>
					<v-row>
						<v-col cols="12">
							<v-row dense wrap>
								<v-col cols="12">
									<InputField
										:maxlength="50"
										v-model="objectEdit.name"
										:errorBorder="!objectEditValidation.name"
										:label="'* ' + $t('fields.name')"
									></InputField>
								</v-col>
								<v-col cols="1">
									<v-simple-checkbox :ripple="false" v-model="objectEdit.active"></v-simple-checkbox>
								</v-col>
								<v-col cols="11" clas="mt-0"> {{ $t('fields.active') }} </v-col>
							</v-row>
							<v-row>
								<v-col
									cols="12"
									md="6"
									class="text-right"
									:class="{ 'text-center': $vuetify.breakpoint.smAndDown }"
								>
									<v-btn color="primary" class="white--text" @click.stop="saveChanges"
										>{{ $t('buttons.save') }}
									</v-btn>
								</v-col>
								<v-col
									cols="12"
									md="6"
									class="text-left"
									:class="{ 'text-center': $vuetify.breakpoint.smAndDown }"
								>
									<v-btn color="secondary" class="white--text" @click.stop="closeDialog"
										>{{ $t('buttons.cancel') }}
									</v-btn>
								</v-col>
							</v-row>
						</v-col>
					</v-row>
				</v-card-text>
			</v-card>
		</v-dialog>
	</v-container>
</template>

<script>
import BasicObject from '../../../models/BasicObject';
import InputField from '../../trinkets/InputField';
export default {
	name: 'BasicObject',
	components: {
		InputField,
	},
	props: ['objectName', 'objectHeader', 'title'],
	data: function () {
		return {
			objectsList: [],
			object: new BasicObject({}),
			objectValidation: new BasicObject({}, true),
			objectEdit: new BasicObject({}),
			objectEditValidation: new BasicObject({}, true),
			lastRequest: null,
			objectEditDialog: false,
			objectHeaders: [{ text: this.objectHeader }, {}],
			showUnactive: false,
		};
	},
	methods: {
		changeStatus(object) {
			let vm = this;
			object.active = !object.active;
			this.$APICall('put', this.objectName + '/' + object.id, object, (data, succes) => {
				if (succes) {
					this.reloadData();
					vm.$notify(vm.$t('alerts.basicUpdate'));
				} else {
					vm.$alert(vm.$t('alerts.basicError'));
				}
			});
		},

		closeDialog() {
			this.objectEditDialog = false;
			this.objectEdit = new BasicObject({});
			this.objectEditValidation = new BasicObject({}, true);
		},

		editObject(object) {
			this.objectEdit = JSON.parse(JSON.stringify(object));
			this.objectEditDialog = true;
		},

		saveChanges() {
			let succes = true;
			if (this.objectEdit.name == '') {
				succes = false;
				this.objectEditDialog.name = false;
			} else {
				this.objectEditValidation.name = true;
			}

			if (succes) {
				let vm = this;
				this.$APICall('put', vm.objectName + '/' + vm.objectEdit.id, vm.objectEdit, (data, succes) => {
					if (succes) {
						this.reloadData();
						vm.$notify(vm.$t('alerts.basicUpdate'));
						this.closeDialog();
					} else {
						vm.$alert(vm.$t('alerts.basicError'));
					}
				});
			}
		},

		saveClick() {
			let succes = true;

			if (this.object.name == '') {
				succes = false;
				this.objectValidation.name = false;
			} else {
				this.objectValidation.name = true;
			}

			if (succes) {
				let vm = this;
				this.$APICall('post', this.objectName, this.object, (data, succes) => {
					if (succes) {
						this.object = new BasicObject({});
						this.reloadData();
						vm.$notify(vm.$t('alerts.basicAdd'));
					} else {
						vm.$alert(vm.$t('alerts.basicError'));
					}
				});
			}
		},

		reloadData() {
			let vm = this;
			this.$APICall(
				'get',
				this.objectName,
				{},
				(data, success) => {
					if (success) {
						vm.objectsList = data.items;
					} else {
						vm.$alert(vm.$t('alerts.basicError'));
					}
				},
				false
			);
		},
	},
	mounted() {
		this.reloadData();
	},
};
</script>
